import CentralTabContent from "../utils/CentralTabContent";

export default function PerformanceDetailsTab(): JSX.Element {
    return <>
        <CentralTabContent className="mt-20 mb-32 text-white">
            No Data Available Yet
        </CentralTabContent>
    </>
}